import {t} from "i18next";
import {Select} from "antd";
import React, {useState} from "react";
import {Currency} from "../../app/Payment/MultiplePaymentApp";

export default function CurrencySelect({short, ...props}) {
    return (
        <Select
            placeholder={t('Currency')}
            style={{width: 80}}
            {...props}
        >
            <Select.Option value={'TRY'}>
                TRY ({Currency['TRY']})
            </Select.Option>
            <Select.Option value={'USD'}>
                USD ({Currency['USD']})
            </Select.Option>
            <Select.Option value={'EUR'}>
                EUR ({Currency['EUR']})
            </Select.Option>
            <Select.Option value={'GBP'}>
                GBP ({Currency['GBP']})
            </Select.Option>
        </Select>
    )
}